<template>
  <span
    class="rounded-xl flex items-center hover:shadow text-sm space-x-2 group relative border whitespace-nowrap border-gray-300 p-1 cursor-pointer duration-150 hover:bg-gray-50 px-4 inline-block"
    :class="[
      !color && 'text-gray-400',
    ]"
    @click="showColor"
  >
    <span class="rounded-full w-3 h-3 relative overflow-hidden" :class="!color && 'border border-gray-300'" :style="{backgroundColor: color}">
      <span v-if="!color" class="bg-gray-300 absolute left-1/2 -ml-[1px] rotate-45 block h-full w-[1px]"></span>
    </span>
    <span class="ml-1 -translate-y-[1px]">{{ label }}</span>

    <span class="absolute shadow right-0 bottom-0 mr-1 mb-1 translate-x-1/2 translate-y-1/2 opacity-0 invisible duration-150" :class="color && 'group-hover:visible group-hover:opacity-100'" @click.stop="color = ''">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-500 duration-150 hover:text-red-600 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
      </svg>
    </span>

    <transition
      enter-class="mt-2 opacity-0"
      leave-class="mt-0 opacity-100"
      enter-to-class="mt-0 opacity-100"
      leave-to-class="mt-2 opacity-0"
    >
      <div v-if="show"
        class="duration-150 absolute left-0 top-full w-[21.5em] max-h-[455px] overflow-hidden bg-white VUETIFY z-10 shadow-lg rounded border border-gray-200"

        v-click-outside="hide"
      >
        <v-app>
          <v-color-picker v-model="color" mode="hexa" show-swatches></v-color-picker>
        </v-app>
      </div>
    </transition>

    <span v-if="!isOverwritting && deletable === undefined || deletable" class="shadow absolute left-0 bottom-0 px-2 border border-gray-200 z-10 rounded-xl bg-white text-xs -translate-x-[8px] translate-y-[18px] gray-50 hover:text-red-600 hover:bg-gray-50 opacity-0 invisible duration-150 group-hover:visible group-hover:opacity-100" @click.stop="$emit('remove')">
      Remove
    </span>


    <div class="absolute w-full h-full left-0 top-0 !ml-0 rounded-xl overflow-hidden z-10 pointer-events-none">
      <div class="w-full h-full ske"></div>
    </div>
  </span>
</template>

<script>

import ColorPicker from 'primevue/colorpicker'

export default {
  components: {
    ColorPicker,
  },
  props: ['label', 'id', 'value', 'deletable', 'isOverwritting'],
  data() {
    return {
      color: this.value || "",
      show: false,
    }
  },
  methods: {
    showColor() {
      requestAnimationFrame(() => this.show = true)
    },
    hide() {
      this.show = false
    },
  },
  watch: {
    value(val) {
      this.color = val
    },
    color(val) {
      this.$emit("input", val )
    },
  },
}

</script>
